<div class="breadcrumb_box">
  <div class="section" [class.grey]="i > 0" (click)="toBack(i)"
    *ngFor="let section of breadcrumbSections; let i = index">
    {{section}}
    <ion-icon name="dp-breadcrumb-chevron" *ngIf="(i + 1) < breadcrumbSections.length"></ion-icon>
  </div>
</div>